<Button
  on:click
  on:focus={() => {focused=true;}}
  on:blur={() => {focused=false;}}
  position="relative" w="22ch" 
  rounded="xs" 
  mb="nm" mr="sm" p="0" pb="sm"
  vertical="top" align="left"
  bg="transparent"
  hover="grid-item-card-hover"
  pointer
  border={focused ? "2" : "1"}
  shadow={focused ? "lg" : "sm"}
  mt={focused ? "-2px" : null}
  >

  <Panel align="right" bg="light-" h="2.75" position="relative" overflow="hidden">
    <Box position="absolute" right="0" bottom="0" mr="sm" mb="sm">
      <Text xxs>{ updated }</Text>
    </Box>
  </Panel>

  <Box position="absolute" top="1" left="1" h="2.5" w="3">
    <Icon name="xls" size="2.25" color="gray600"/>
    <Box 
      position="absolute" top="0" left="1.5"
      w="18px" h="18px" 
      round
      line="20px" 
      pl="6px"
      font-size="xxs" 
      font-weight="bold" 
      {...states[state]}
      >
      {state}
    </Box>
  </Box>

  <Panel mt="sm" ml="nm" pt="sm" pr="xs" mr="sm" overflow="hidden">
    <Text sm bold color="black-" nowrap>{title}</Text>
  </Panel>

  <Panel ml="nm" mt="0" overflow="hidden" mr="nm" h="2"  line="0.75" >
    <Text font-size="11px" color="muted">{descr || ''}</Text>
  </Panel>

</Button>

<script>
  import { Box, Icon, Panel, Text, Label, Button } from 'svelte-stylo';
  import { Theme } from 'svelte-stylo'

  export let
    id = '', 
    title = '',
    descr = '',
    updated = '',
    icon = '',
    state= '';

  let 
    theme = Theme.get("default"),
    states = theme.variants['states'],
    focused = false;

</script>

<style>
  :global(.grid-item-card-hover:hover) {
    box-shadow: 4px 6px 12px #ddd;
    margin-top: -2px;
  }  
</style>
